<template>
	<div ref="contentEditorWrapper">
		<div class="font-weight-medium">Sorting folder</div>
		<v-form ref="form" @submit.prevent="saveFolderToFirestore">
			<v-text-field
				class="mx-3 mt-6"
				label="Name"
				v-model="label"
				:rules="agile.fieldRules.nameRules"
				outlined
				dense
			></v-text-field>
			<v-toolbar flat elevation-1 class="ml-n4 pl-0" style="background: rgba(255, 255, 255, 0.0) !important;">
			<v-spacer/>
			<v-btn class="mr-n4 mb-3" @click="saveFolderToFirestore">
				Save
			</v-btn>
		</v-toolbar>
		</v-form>
	</div>
</template>


<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";
import fb from '@/shift/fb';


export default
{
    name: 'ContentEditFolder',

	props:
	{
		dio: { type: Object }
	},
	
    data: () =>
    ({
		label: '',
		allowFirestoreSave: true,
    }),

    computed:
	{
        agile()
        {
            return agile;
		},
		
		routeKey()
		{
			return this.$route.params.key;
		},
		
	},

	watch:
	{
		'dio.wrapper.docData.editorMetaData.treeNodeLabel'()
		{
			this.label = this.dio.wrapper.docData.editorMetaData.treeNodeLabel;
		},

	},

	created()
	{
		this.label = this.dio.wrapper.docData.editorMetaData.treeNodeLabel;
	},

    mounted()
    {
		//console.log(this.dio);
        // Save document when pressing "Ctrl+S"
        document.addEventListener("keydown", this.onKeyPressSave);
    },

    methods:
    {

		onKeyPressSave(e)
		{
			if (!(e.keyCode === 83 && e.ctrlKey))
			{
				return;
			}

			// Make sure we are only saving this tabs document.
			// This code below checks if the component is wrapped in an element with display: none; or not
			// Not foolproof though: https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom

			if (this.$refs.contentEditorWrapper.offsetParent)
			{
				this.saveFolderToFirestore();
			}
			
			e.preventDefault();
			
		},



		saveFolderToFirestore()
		{
			//console.log(this.documentType); fb;
			if (this.$refs.form.validate())
			{
				if (this.allowFirestoreSave)
				{
					this.allowFirestoreSave = false;
					
					const doc = fb.db
						.collection('content-collection')
						.doc('content-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('shared-content-sorting-folders')
						.doc(this.dio.id);

					doc.set( { editorMetaData: { treeNodeLabel: this.label } }, { merge: true } )
					.then(() =>
					{
						this.$root.ai_app.snackbarText = `Saved folder ${this.label}`;
						this.$root.ai_app.snackbarTimeout = 4000;
						this.$root.ai_app.snackbar = true;
					})
					.catch((error) =>
					{
						console.log('Error updating sorting folder label:', error.message);
					});
					

					// Protection against spamming firestore, i.e. if the user keeps holding Ctrl+S down
					
					setTimeout(() =>
					{
						this.allowFirestoreSave = true;
					}, 1000);
				}
			}
		},
	},
	



	
	beforeDestroy()
	{
		document.removeEventListener("keydown", this.onKeyPressSave);
	},

}

</script>
